module.exports = {"vesselName":null,"vessel":null,"ideaPrice":0,"salePrice":0,"user":null,"validateErrors":[],"successMessage":{}}


//////////////////
// WEBPACK FOOTER
// ./app/mocks/vessel/sales.json
// module id = 702
// module chunks = 0